import fetch from "auth/FetchInterceptor";
import interviewSlice from "store/slices/interviewSlice";

const InterviewSlice = {};

InterviewSlice.GetInterviewSSR = async function (data) {
  return fetch({
    url: "/Interview/GetAllSSR",
    method: "post",
    data: data,
  });
};

InterviewSlice.CreateInterview = async function (data) {
  return fetch({
    url: "/Interview/Create",
    method: "post",
    data: data,
  });
};
InterviewSlice.GetInterviewsByApplicationId = async function (params) {
  return fetch({
    url: "/Interview/GetInterviewByApplicationId",
    method: "get",
    params,
  });
};

InterviewSlice.UpdateInterview = async function (data) {
  return fetch({
    url: "/Interview/Update",
    method: "post",
    data: data,
  });
};
InterviewSlice.GetInterviewById = async function (params) {
  return fetch({
    url: "/Interview/GetById",
    method: "get",
    params,
  });
};
InterviewSlice.GetInterviewStatus = async function () {
  return fetch({
    url: "/Interview/GetInterviewStatus",
    method: "get",
  });
};
InterviewSlice.SetActive = async function (params) {
  return fetch({
    url: "/Interview/SetIsActive",
    method: "get",
    params,
  });
};
InterviewSlice.GetCriteria = async function () {
  return fetch({
    url: "/Interview/GetCriteria",
    method: "get",
  });
};
InterviewSlice.GetLevels = async function () {
  return fetch({
    url: "/Interview/GetLevels",
    method: "get",
  });
};
InterviewSlice.AddCriteria = async function (data) {
  return fetch({
    url: "/Interview/AddCriteria",
    method: "post",
    data,
  });
};

export default InterviewSlice;
